import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Banner {
  info: string;
  type: keyof typeof bannerTypes;
}

const bannerTypes = {
  success: 'bg-green-100 text-green-800',
  warning: 'bg-orange-100 text-orange-800',
  danger: 'bg-red-100 text-red-800',
};

const NotificationBanner: FC<Banner> = ({ info, type }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`w-100 fixed mt-2 bottom-0 py-2 px-5 z-10 ${bannerTypes[type]}`}
    >
      {t(info)}
    </div>
  );
};

export default NotificationBanner;
